import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useAuth } from '@/store/auth'

export function Memory() {
  const { id } = useParams<{ id: string }>()
  const api = useAuth((s) => s.api)()
  const qc = useQueryClient()
  const [content, setContent] = useState('')
  const [saving, setSaving] = useState(false)

  const { data, isLoading } = useQuery({
    queryKey: ['memory', id],
    queryFn: () => api.getMemory(id!),
    enabled: !!id,
  })

  async function addMemory() {
    if (!content.trim()) return
    setSaving(true)
    try {
      await api.addMemory(id!, content.trim())
      setContent('')
      qc.invalidateQueries({ queryKey: ['memory', id] })
    } finally {
      setSaving(false)
    }
  }

  return (
    <div>
      <div className="cp-card" style={{ marginBottom: 20 }}>
        <div className="cp-form">
          <div className="cp-field">
            <label className="cp-label">Add memory</label>
            <textarea
              className="cp-textarea"
              placeholder="Something to remember…"
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
          </div>
          <button className="cp-btn cp-btn--primary" style={{ alignSelf: 'flex-start' }} onClick={addMemory} disabled={saving || !content.trim()}>
            {saving ? 'Saving…' : 'Add'}
          </button>
        </div>
      </div>

      {isLoading && <p className="cp-empty">Loading…</p>}
      {!isLoading && !data?.memories.length && <p className="cp-empty">No memories yet.</p>}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {data?.memories.map((m) => (
          <div key={m.id} className="cp-card">
            <div style={{ fontSize: 13, marginBottom: 4, color: 'var(--ae-color-neutral-400)' }}>
              {m.type} · {new Date(m.created_at).toLocaleDateString()}
            </div>
            <div style={{ fontSize: 14 }}>{m.content}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
